module.exports = __webpack_public_path__ + "img/AMERSPORTS-icon.ee2c5ca6.png";